export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT'
export const AUTH_EXPIRY_ALERT = 'AUTH_EXPIRY_ALERT'